// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3UYtl","icon":"icon___2HhhQ","text":"text___3scdd"};